<template>
  <page-outline :title="$t('administration.ocrtemplate_add')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutters">
          <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <form-accordion :title="$t('administration.ocr_templates')" :isTitleUpperCase="false">
        <b-row>
          <b-col sm="6" class="form-group">
            <b-row v-for="(attachment, id) in attachments" :key="id"
              class="justify-content-start mx-0 mb-3 px-0 align-items-center">
              <b-col cols="4" class="d-flex ml-0">
                <div class="d-flex justify-content-between">
                  <label v-model="attachment.Name"
                    id="application-file-input">
                    {{ attachment.Name }}
                  </label>
                </div>
                <div class="d-flex ml-4">
                  <i class="fa-light fa-download" @click="view(id)"></i>
                  <i class="fa-light fa-magnifying-glass ml-3" @click="openDoc(id)"></i>
                </div>
              </b-col>
              <b-button variant="primary" round class="mb-0"
                @click="clearInvoice(id)">
                {{ $t('common.del_label') }}
              </b-button>
            </b-row>
            <b-row class="justify-content-start">
              <b-col cols="6" class="form-group mb-0">
                <b-button round class="btn" size="md"
                  @click="openImportTemplate()">
                  <i class="fa-light fa-upload mr-2" size="17px"></i>
                  {{ $t('attachments.import_doc') }}
                </b-button>
              </b-col>
              <input class="item-input hiddenElementAllSize local-file-input"
                type="file"
                :key="refreshImport"
                @change="saveDocument($event)">
              </input>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <form-write-group-label-input v-model="emissionDate"
              :inputLabel="$t('administration.emission_date')" :placeholderValue="$t('administration.emission_date')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="deliveryDate"
              :inputLabel="$t('administration.delivery_date')" :placeholderValue="$t('administration.delivery_date')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="paymentDate" isMandatory
              :inputLabel="$t('administration.payment_date')" :placeholderValue="$t('administration.payment_date')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <form-write-group-label-input v-model="reference" isMandatory
              :inputLabel="$t('administration.reference')" :placeholderValue="$t('administration.reference')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="numberClient"
              :inputLabel="$t('administration.number_client')" :placeholderValue="$t('administration.number_client')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="creditorName" isMandatory
              :inputLabel="$t('administration.creditor_name')" :placeholderValue="$t('administration.creditor_name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <form-write-group-label-input v-model="creditorPostalCode" isMandatory
              :inputLabel="$t('administration.creditor_postal_code')" :placeholderValue="$t('administration.creditor_postal_code')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="creditorTownName" isMandatory
              :inputLabel="$t('administration.creditor_town_name')" :placeholderValue="$t('administration.creditor_town_name')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="creditorStreetName" isMandatory
              :inputLabel="$t('administration.creditor_street_name')" :placeholderValue="$t('administration.creditor_street_name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <form-write-group-label-input v-model="creditorEmail"
              :inputLabel="$t('administration.creditor_email')" :placeholderValue="$t('administration.creditor_email')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="creditorPhone"
              :inputLabel="$t('administration.creditor_phone')" :placeholderValue="$t('administration.creditor_phone')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="creditorIBAN"
              :inputLabel="$t('administration.creditor_iban')" :placeholderValue="$t('administration.creditor_iban')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <form-write-group-label-input v-model="name" isMandatory
              :inputLabel="$t('administration.name')" :placeholderValue="$t('administration.name')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="postalCode" isMandatory
              :inputLabel="$t('administration.postal_code')" :placeholderValue="$t('administration.postal_code')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="townName" isMandatory
              :inputLabel="$t('administration.town_name')" :placeholderValue="$t('administration.town_name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <form-write-group-label-input v-model="streetName" isMandatory
              :inputLabel="$t('administration.street_name')" :placeholderValue="$t('administration.street_name')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="Email"
              :inputLabel="$t('administration.email')" :placeholderValue="$t('administration.email')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="phone"
              :inputLabel="$t('administration.phone')" :placeholderValue="$t('administration.phone')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <form-write-group-label-input v-model="iban"
              :inputLabel="$t('administration.iban')" :placeholderValue="$t('administration.iban')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="amount" isMandatory
              :inputLabel="$t('administration.amount')" :placeholderValue="$t('administration.amount')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="amountHT" isMandatory
              :inputLabel="$t('administration.amountHT')" :placeholderValue="$t('administration.amountHT')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <form-write-group-label-input v-model="amountTVA"
              :inputLabel="$t('administration.amountTVA')" :placeholderValue="$t('administration.amountTVA')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
            <form-write-group-label-input v-model="reason" isMandatory
              :inputLabel="$t('administration.reason')" :placeholderValue="$t('administration.reason')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3">
          </b-col>
        </b-row>

      </form-accordion>
    </template>
  </page-outline>
</template>

<script>

import backButton from "@/components/common/backButton.vue"
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'AddOCRTemplatePage',
  components: {
    'back-button': backButton,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      amount,
      amountHT,
      amountTVA,
      attachments: [],
      creditorEmail,
      creditorIBAN,
      creditorName,
      creditorPhone,
      creditorPostalCode,
      creditorStreetName,
      creditorTownName,
      deliveryDate,
      email,
      iban,
      name,
      numberClient,
      paymentDate,
      phone,
      postalCode,
      reason,
      reference,
      refreshImport: false,
      returnUrl: '/ocrtemplatelist/',
      streetName,
      townName
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    clearInvoice (id) {
      this.attachments.splice(id, 1)
    },
    openImportTemplate () {
      let that = this
      that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
    },
    saveDocument ($event) {
      console.log($event)
      this.attachments.push({
        Name: $event.target.files[0].name
      })
    },
    saveTemplate () {
      data = {
        DocumentData: this.attachment[0].Data,
        DocumentName: this.attachment[0].Name,
        Template: {
          EmissionDate: this.emissionDate,
          DeliveryDate: this.deliveryDate,
          PaymentDate: this.paymentDate,
          Reference: this.reference,
          NumberClient: this.numberClient,
          CreditorName: this.creditorName,
          CreditorPostalCode: this.creditorPostalCode,
          CreditorTownName: this.creditorTownName,
          CreditorStreetName: this.creditorStreetName,
          CreditorEmail: this.creditorEmail,
          CreditorPhone: this.creditorPhone,
          CreditorIBAN: this.creditorIBAN,
          Name: this.name,
          PostalCode: this.postalCode,
          TownName: this.townName,
          StreetName: this.streetName,
          Email: this.Email,
          Phone: this.phone,
          Iban: this.iban,
          Amount: this.amount,
          AmountHT: this.amountHT,
          AmountTVA: this.amountTVA,
          Reason: this.reason
        }
      }
      console.log(data)
    }
  }
}

</script>
